import type { ApiError } from '@app/services/api.types';
import webchatApi from '@app/services/webchat-api';
import type {
    StartChatSessionParams,
    StartChatSessionResponse,
    WebchatTurn,
} from '@app/services/webchat.types';
import { apiEndpoints } from '@app/utils/constants';
import { useQuery } from '@tanstack/react-query';

export const startChatSession = async (params: StartChatSessionParams): Promise<WebchatTurn> => {
    const url = apiEndpoints.webchat.startSession(params.agentId);
    const response = await webchatApi.post<StartChatSessionResponse>(url);
    return response.data.data;
};

const useStartChatSession = (agentId: string) => {
    return useQuery<WebchatTurn, ApiError>({
        queryKey: ['webchat', 'session', agentId],
        queryFn: () => startChatSession({ agentId }),
        enabled: !!agentId,
        retry: false,
        staleTime: Infinity,
        gcTime: Infinity,
        meta: {
            skipGlobalErrorHandling: true,
        },
    });
};

export default useStartChatSession;
